import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { i18n_more_info } from '@yi/i18n/phrases/i18n_more_info';

import { Link as LinkBase } from 'gatsby';
import { analytics } from '~/common';
import { CardType } from '~/types';

import { MenuItemStyles } from './elements';
import { InfoIcon } from '../icons';
import { useLocale } from '../LocaleProvider';

const { sendMoreInfoClicked } = analytics;

interface FullInfoButtonProps {
  localizedPath: string;
  contentTitle?: string;
  cardType?: CardType;
}

const Link = styled(LinkBase)`
  ${MenuItemStyles}
  gap: 6px;
`;

export const FullInfoButton: React.FC<PropsWithChildren<FullInfoButtonProps>> = ({
  localizedPath,
  contentTitle,
  cardType,
}) => {
  const { locale } = useLocale();
  return (
    <Link
      style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
      to={localizedPath}
      onClick={() => sendMoreInfoClicked({ title: contentTitle || '', cardType })}
      aria-label="full info link"
    >
      <InfoIcon innerOpacity={0.7} />
      {i18n_more_info(locale)}
    </Link>
  );
};
